import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Container } from 'ui/container'
import { Banner } from 'features/friends/banner'
import { List } from 'features/friends/list'
import { useEffect, useState } from 'react'
import { apiClient } from 'core/http'
import { SupportIcon } from '../../ui/icons'

import c from './assets/sass/page.module.scss'

const FriendsPage = () => {
    const { t } = useTranslation()
    const [total, setTotal] = useState(null)

    useEffect(() => {
        const load = async () => {
            try {
                const res = await apiClient.get('/friends')
                if (res?.data?.success) {
                    setTotal(
                        res.data.stats?.total ?? res.data.friends?.length ?? 0
                    )
                }
            } catch (e) {}
        }
        load()
    }, [])

    const navigate = useNavigate()
    const handleFAQ = () => {
        navigate('/faq?category=referrals')
    }

    return (
        <div className={c.component}>
            <div className={c.title}>
                <span>{t('pages.friends.title')}</span>
                <span className={c.titleCounter}>{total ?? 0}</span>
                <button type="button" className={c.btn} onClick={handleFAQ}>
                    <SupportIcon />
                </button>
            </div>
            <Container>
                <Banner />
                <List />
            </Container>
        </div>
    )
}

export default FriendsPage
